export default "__VITE_ASSET__5ebbfc54__"